import { render, staticRenderFns } from "./publishRules.vue?vue&type=template&id=68972436&scoped=true&"
import script from "./publishRules.vue?vue&type=script&lang=js&"
export * from "./publishRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68972436",
  null
  
)

export default component.exports